import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useRecoilValue} from "recoil";
import {currentQuestionIndexState, numberOfRootQuestionState} from "../../states/test_progress_states";
import {useRecoilState, useSetRecoilState} from "recoil/dist";
import {valueSlideState} from "../../states/states";

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        width: "100%",
        display: 'flex',
        overflow: "auto",
        webkitOverflow: "auto",
        borderBottom: "3px solid #fff !important"
    },
    slideDiv: {
        padding: '10px 25px 10px 25px',
        fontWeight: 'bold',
        fontSize: 15,
    },
}));

export default function ScrollableTabsButtonAuto(props) {
    const classes = useStyles();
    const {isShowSlide} = props;
    const numberOfQuestions = useRecoilValue(numberOfRootQuestionState);
    const setCurrentQuestionIndex = useSetRecoilState(currentQuestionIndexState);
    const [valueSlide, setValueSlide] = useRecoilState(valueSlideState);

    useEffect(() => {
        for (let i = 1; i <= numberOfQuestions; i++) {
            if (document.getElementById(`slide${i}`)) {
                if (valueSlide === i) {
                    var elment = document.getElementById(`slide${i}`);
                    elment.style.borderBottom = "3px solid #ced2d8";
                    elment.scrollIntoView();
                } else {
                    document.getElementById(`slide${i}`).style.borderBottom = "none";
                }
            }
        }
    }, [valueSlide]);

    if (isShowSlide) {
        const arrNumberOfQuestions = new Array(numberOfQuestions);
        arrNumberOfQuestions.fill(1);
        return (
            <div className={classes.root}>
                {arrNumberOfQuestions.map((item, key) => {
                    let idSlideQuestion = `slide${key + 1}`;
                    return (
                        <div
                            className={classes.slideDiv}
                            key={key + 1}
                            id={idSlideQuestion}
                            onClick={() => {
                                if (document.getElementById(idSlideQuestion)) {
                                    document.getElementById(idSlideQuestion).style.borderBottom = "3px solid #ced2d8";
                                }
                                for (let i = 1; i <= numberOfQuestions; i++) {
                                    if (i !== (key + 1) && document.getElementById(`slide${i}`)) {
                                        document.getElementById(`slide${i}`).style.borderBottom = "none";
                                    }
                                }
                                setCurrentQuestionIndex(key + 1);
                                setValueSlide(key + 1);
                            }}>{key + 1}</div>
                    )
                })}
            </div>
        );
    }
    return <></>;
}
